import { GetServerSideProps } from 'next';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import PSTIStatement from '@elem/compPage/PSTIStatement';
import { useRouter } from 'next/router';
import { useLang } from '@/i18n';

const PSTI: React.FC<any> = ({ SEO }) => {
    const { locale } = useRouter();
    const { t } = useLang('psti');

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={['uk']} pathname={'psti-statement'} />
            <PageLayout children={<PSTIStatement />} />
        </>
    );
};

export default PSTI;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
    const whiteLocaleList = ['uk'];
    if (!whiteLocaleList.includes(locale as string)) {
        return { notFound: true };
    }

    return {
        props: {},
    };
};
